"use client";

import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function BrowseByState() {
  const chicagoBranch = [{
    code: "IL",
    name: "Illinois"
  }, {
    code: "IA",
    name: "Iowa"
  }, {
    code: "IN",
    name: "Indiana"
  }, {
    code: "WI",
    name: "Wisconsin"
  }, {
    code: "NE",
    name: "Nebraska"
  }];
  const westBranch = [{
    code: "AZ",
    name: "Arizona"
  }];
  const southBranch = [{
    code: "NC",
    name: "North Carolina"
  }, {
    code: "SC",
    name: "South Carolina"
  }, {
    code: "VA",
    name: "Virginia"
  }];
  return <section data-section-id="229441" id="licensedstatescoverage" className="bg-background py-12 px-4 sm:px-6 lg:px-8 text-foreground">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h1 className="font-default text-3xl font-bold text-foreground sm:text-4xl">
            Licensed Multi-Branch Coverage
          </h1>
          <p className="mt-4 text-base font-sans text-muted-foreground">
            Providing industrial excellence across our nine-state operational footprint.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <div className="w-full lg:w-1/2 flex flex-col gap-6">
            <Card className="border-border bg-card">
              <CardHeader>
                <CardTitle className="text-lg font-bold font-default">ABCO South Electric</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {southBranch.map((state, i) => <li key={state.code} data-index={i} className="font-sans text-xs text-foreground">
                      <span className="font-bold">{state.code}</span> – {state.name}
                    </li>)}
                </ul>
              </CardContent>
            </Card>

            <Card className="border-border bg-card">
              <CardHeader>
                <CardTitle className="text-lg font-bold font-default">ABCO Electric Chicago</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {chicagoBranch.map((state, i) => <li key={state.code} data-index={i} className="font-sans text-xs text-foreground">
                      <span className="font-bold">{state.code}</span> – {state.name}
                    </li>)}
                </ul>
              </CardContent>
            </Card>

            <Card className="border-border bg-card">
              <CardHeader>
                <CardTitle className="text-lg font-bold font-default">ABCO West Electric</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {westBranch.map((state, i) => <li key={state.code} data-index={i} className="font-sans text-xs text-foreground">
                      <span className="font-bold">{state.code}</span> – {state.name}
                    </li>)}
                </ul>
              </CardContent>
            </Card>
          </div>

          <div className="w-full lg:w-1/2">
            <Link className="w-full h-auto max-w-7xl rounded-lg underline cursor-pointer" to="/OperationalFootprintPage"><img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/ABCO.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/ABCO.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/ABCO.png-wvc-sizes" alt="ABCO South Electrical Construction and Design ABCO South Electric NC – North Carolina SC – South Carolina VA – Virginia ABCO Electric Chicago IL – Illinois IA – Iowa IN – Indiana WI – Wisconsin NE – Nebraska ABCO West Electric AZ – Arizona" className="w-full h-auto max-w-7xl rounded-lg" loading="lazy" decoding="async" /></Link>
          </div>
        </div>
      </div>
    </section>;
}